'use client'

import { Link, type LinkProps } from 'react-aria-components/Link'

import { navbarItem } from '../recipe'

interface NavbarLinkProps extends Omit<LinkProps, 'className'> {
    className?: string
}

export function NavbarLink({ className, target = '_blank', rel = 'noreferrer noopener', ...props }: NavbarLinkProps) {
    return (
        <li className={className}>
            <Link className={navbarItem()} target={target} rel={rel} {...props} />
        </li>
    )
}
